var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.714,
    height: 13.486,
    viewBox: "0 0 14.714 13.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041C\\u0430\\u0433\\u0430\\u0437\\u0438\\u043D\\u0438",
    d: "M14.586,24.022a.6.6,0,0,0-.476-.232H2.6l-.171-1.905a.6.6,0,0,0-.6-.55H.6a.6.6,0,1,0,0,1.209H1.28l.662,7.379c0,.009,0,.017,0,.026a.608.608,0,0,0,.008.068l.024.27,0,.015a2.326,2.326,0,0,0,.869,1.56,1.831,1.831,0,1,0,3.165.5H9.317a1.832,1.832,0,1,0,1.723-1.209H4.292a1.122,1.122,0,0,1-1.032-.68l9.657-.568a.6.6,0,0,0,.551-.457L14.7,24.54A.6.6,0,0,0,14.586,24.022Z",
    transform: "translate(0 -21.334)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/Shop.af9a23a493d98ba22495879f1298c59b.svg";
export { ForwardRef as ReactComponent };